import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col } from 'antd';
import footerImg from '../../../image/home/Swasth-provider-footer-bg.png';
import SignUpImg from '../../../image/home/Swasth-provider-signup-btn.png';
import swasthLogo from '../../../image/swasth-clinicians-blue.png';
import unitedStates from '../../../image/ENus_en.png';

const Footer = () => (
  <footer id='footer'>
    <div className='inner'>
      <img className='footer-bg' src={footerImg} alt='footer' />
      <div className='footer-widgets-wrap pb-4 clearfix'>
        <Row>
          <Col lg={8} md={6} sm={0} xm={0}>
            <div className='widget clearfix'>
              <img alt='swasth-logo' className='swasth-logo' src={swasthLogo} />
            </div>
          </Col>
          <Col lg={4} md={6} sm={24}>
            <div className='widget clearfix'>
              <h4 className='base-text'>Resiliens</h4>
              <ul className='list-unstyled iconlist ml-0'>
                <li>
                  <a href='https://clinician.resiliens.com/' className='base-text'>Clinicians</a>
                </li>
                <li>
                  <a href='#' className='base-text'>Members</a>
                </li>
              </ul>
            </div>
          </Col>{' '}
          <Col lg={4} md={6} sm={24}>
            <div className='widget clearfix'>
              <h4 className='base-text'>Products</h4>

              <ul className='list-unstyled iconlist ml-0'>
                <li>
                  <a className='base-text' href='https://resiliens.com/dbt-coach'>DBT Coach</a>
                </li>
                <li>
                  <a className='base-text' href='https://resiliens.com/cbt-companion'>CBT Companion</a>
                </li>
                <li>
                  <a className='base-text' href='https://resiliens.com/act-coach'>ACT Coach</a>
                </li>
                {/*<li>*/}
                  {/*<a className='base-text' href='/dbt-daily'>DBT Daily</a>*/}
                {/*</li>*/}
                <li />
                <li>
                  <a className='base-text' href='https://findprovider.swasth.co'>Find Provider</a>
                </li>
              </ul>
            </div>
          </Col>{' '}
          <Col lg={4} md={6} sm={24}>
            <div className='widget clearfix'>
              <h4 className='para-text'>Social</h4>

              <ul className='list-unstyled iconlist'>
                <li>
                  <i className='icon-facebook' />
                  <a className='base-text' href='https://www.facebook.com/swasthco/' target='_blank'>
                    {' '}
                    Facebook
                  </a>
                </li>
                <li>
                  <i className='icon-twitter' />
                  <a className='base-text' href='https://www.twitter.com/swasthapps/' target='_blank'>
                    {' '}
                    Twitter
                  </a>
                </li>
                <li>
                  <i className='icon-instagram' />
                  <a className='base-text' href='https://www.instagram.com/swasthapps/' target='_blank'>
                    {' '}
                    Instagram
                  </a>
                </li>
                <li>
                  <i className='icon-youtube' />
                  <a className='base-text'
                    href='https://www.youtube.com/channel/UCtM20mp-kA1xkKdWA5Q-9KA'
                    target='_blank'
                  >
                    {' '}
                    YouTube
                  </a>
                </li>
              </ul>
            </div>
          </Col>
          <Col lg={4} md={0} sm={0} />
        </Row>
      </div>
      {/* <div className='line line-sm m-0' /> */}
      <div className='footer-top'>
        <div className='text-box'>
          <h1 className='target-text base-text'>Interested in Resiliens for clinicians</h1>
          <p className='para-text'> A comprehensive platform for evidence based therapy</p>
        </div>
        <div>
          <Link to='/signup'>
            <img src={SignUpImg} alt='signup' className='signup_now-btn' />
          </Link>
        </div>
      </div>
      <div id='copyrights' className='nobg'>
        <div className='container clearfix'>
          <div className='col flex-space-between'>
            <div className='copyright-links -highlighted-secondary-text'>
              <a className='base-text' to='https://www.resiliens.com/terms'>Terms of Use</a> {'    |    '}
              <a className='base-text' to='https://www.resiliens.com/privacy'>Privacy Policy</a>
            </div>
            <div style={{ color: 'rgba(0,0,0,0.2)' }}>
              Copyrights &copy; 2019 All Rights Reserved by Resiliens Inc.
              <br />
            </div>
            <div
              className='-highlighted-secondary-text'
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
              <img src={unitedStates} alt='US English' />
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
